(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sign-catalog-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sign-catalog]').forEach((catalog) => {
    const search = catalog.querySelector('[data-sign-product-search]');
    const filterButtons = [...catalog.querySelectorAll('[data-sign-filter]')];
    const sort = catalog.querySelector('[data-sign-product-sort]');
    const grid = catalog.querySelector('[data-sign-product-grid]');
    const cards = [...catalog.querySelectorAll('[data-sign-product-card]')];
    const count = catalog.querySelector('[data-sign-result-count]');
    const empty = catalog.querySelector('[data-sign-no-results]');
    let activeFilter = 'all';

    const updateCatalog = () => {
      const query = search.value.trim().toLowerCase();
      let visibleCount = 0;

      cards.forEach((card) => {
        const categoryMatch = activeFilter === 'all' || card.dataset.productCategory === activeFilter || activeFilter === 'available' && card.dataset.productAvailable === 'true';
        const searchMatch = card.dataset.productSearch.includes(query);
        const visible = categoryMatch && searchMatch;
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      count.textContent = `${visibleCount} ${catalog.dataset.resultLabel}`;
      empty.hidden = visibleCount !== 0;
    };

    const sortCards = () => {
      const mode = sort.value;
      const sortedCards = [...cards];

      if (mode === 'price-ascending') sortedCards.sort((a, b) => Number(a.dataset.productPrice) - Number(b.dataset.productPrice));
      if (mode === 'price-descending') sortedCards.sort((a, b) => Number(b.dataset.productPrice) - Number(a.dataset.productPrice));
      if (mode === 'title-ascending') sortedCards.sort((a, b) => a.dataset.productTitle.localeCompare(b.dataset.productTitle));
      if (mode === 'featured') sortedCards.sort((a, b) => Number(a.dataset.productPosition) - Number(b.dataset.productPosition));

      sortedCards.forEach((card) => grid.appendChild(card));
    };

    search.addEventListener('input', updateCatalog);
    sort.addEventListener('change', () => {
      sortCards();
      updateCatalog();
    });

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.signFilter;
        filterButtons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        updateCatalog();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sign-cinematic-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sign-film').forEach((section) => {
    const video = section.querySelector('.sign-film__video');
    const button = section.querySelector('.sign-film__control');
    const icon = section.querySelector('.sign-film__control-icon');

    if (!video || !button || !icon) return;

    const updateControl = () => {
      const paused = video.paused;
      button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      button.setAttribute('aria-pressed', paused ? 'true' : 'false');
      icon.textContent = paused ? '▶' : 'Ⅱ';
    };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();

    button.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
      updateControl();
    });

    video.addEventListener('play', updateControl);
    video.addEventListener('pause', updateControl);
    updateControl();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sign-product-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sign-pdp').forEach((section) => {
    const slides = [...section.querySelectorAll('[data-media-slide]')];
    const thumbs = [...section.querySelectorAll('[data-media-index]')];
    const dialog = section.querySelector('.sign-pdp__dialog');
    const dialogImage = section.querySelector('.sign-pdp__dialog-image');
    const closeButton = section.querySelector('.sign-pdp__dialog-close');
    const variantSelect = section.querySelector('[data-sign-variant]');
    const orderButton = section.querySelector('.sign-pdp__order');
    const orderLabel = section.querySelector('[data-sign-order-label]');
    const orderPrice = section.querySelector('[data-sign-order-price]');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const target = thumb.dataset.mediaIndex;
        slides.forEach((slide) => {
          slide.hidden = slide.dataset.mediaSlide !== target;
          slide.classList.toggle('is-active', slide.dataset.mediaSlide === target);
        });
        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-current', active ? 'true' : 'false');
        });
      });
    });

    section.querySelectorAll('[data-zoom-src]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!dialog || !dialogImage) return;
        dialogImage.src = button.dataset.zoomSrc;
        dialogImage.alt = button.dataset.zoomAlt || '';
        dialog.showModal();
      });
    });

    if (dialog && closeButton) {
      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    }

    if (variantSelect && orderButton && orderLabel && orderPrice) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        const available = option.dataset.available === 'true';
        orderButton.disabled = !available;
        orderLabel.textContent = available ? orderButton.dataset.addLabel : orderButton.dataset.soldOutLabel;
        orderPrice.textContent = option.dataset.price;
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
